appSocial.controller('registrationPage', [
    '$scope', '$state', '$ionicModal', 'SocialLocaleService', 'SocialUtils', 'SocialActionService',
    function ($scope, $state, $ionicModal, SocialLocaleService, SocialUtils, SocialActionService) {
        class RegistrationPage {
            constructor() {
                this.translation = SocialLocaleService.translation;
                this.$scope = $scope;
                this.$state = $state;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                /**
                 * @type {SocialActionService}
                 */
                this.actionService = SocialActionService;

                this.terms = false;
            }

            register() {
                this.actionService.register();
            }
        }

        return new RegistrationPage()
    }]);

